module.exports = __webpack_public_path__ + "img/slide2.f16dc9ba.jpg";